export const CUSTOMER_CONTRIBUTIONS_GRAPHQL_QUERY = `
    query ($historicalQuery: HISTORICAL_ContributionsCustomerCriteria) {
        getCustomerContributions(query: $historicalQuery) {
            id
            pickupDate
            totalPaidByBroker
            totalPaidByShipper
            totalPaidByCustomer
            customerName
            shipperName
            brokerName
            carrierName
            brokerPaymentType
            shipperPaymentType
            contributorType
            equipType
        }
    }
`;